import { toast } from "react-toastify";

const DEFAULT_OPTIONS = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const TOAST_BY_STATUS = {
  info: toast.info,
  success: toast.success,
  warning: toast.warning,
  error: toast.error,
};

export function useAppToast() {
  return ({ description, status, ...options }) => {
    const show = TOAST_BY_STATUS[status];
    if (!show) {
      throw new Error(`Unsupported status type: ${status}`);
    }
    show(description, { ...DEFAULT_OPTIONS, ...options });
  };
}
